const types = {
  EMPTY: 'empty',
  MISC: 'misc',
  AUTH: 'auth',
  AUTH_REPORT: 'auth-reporting',
  APP: 'app',
  REDUCEV3: 'reducev3',
} as const;

export type LayoutType = (typeof types)[keyof typeof types];

export default types;
